const comMeta = { lang: 'zh' }

const solution = [
  {
    path: '/solution-chain-retail',
    name: `solution-chain-retail`,
    component: () => import('@/views/solution/chainRetail'),
    meta: {
      ...comMeta,
      title: '解决方案',
      metaInfo: {
        title: '华盟·税纪云 _解决方案'
      }
    }
  },
  // {
  //   path: '/solution-detail/:id',
  //   name: `solution-detail`,
  //   component: () => import('@/views/news/newsCenter/newsDetail'),
  //   meta: {
  //     ...comMeta,
  //     title: '新闻详情',
  //     nav: 'solution'
  //   }
  // },
  // {
  //   path: '/news-advertisement',
  //   name: `news-advertisement`,
  //   component: () => import('@/views/news/advertisement'),
  //   meta: {
  //     ...comMeta,
  //     title: '市场活动'
  //   }
  // },
  // {
  //   path: '/news-advertIntroduction/:id',
  //   name: `news-advertIntroduction`,
  //   component: () => import('@/views/news/advertisement/advertIntroduction'),
  //   meta: {
  //     ...comMeta,
  //     title: '活动详情',
  //     nav: 'news-advertisement'
  //   }
  // }
]

export default solution



// WEBPACK FOOTER //
// ./src/router/modules/solution.js